import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Assortments from "src/components/panel/meal/assortment/Assortments";

const AssortmentView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("meal_assortments_list_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("meal_assortments_list_title")}
          subtitle={t("meal_assortments_list_subtitle")}
        />
        <Assortments />
      </Sidebar>
    </>
  );
};

export default AssortmentView;
